const storesState = {
  list: [],
  picks: [],
}

export default storesState
